import apiSuppliersConfig from 'json!../../../../config/api-suppliers.json';

class transfersTableService {
    constructor($http, cacheService, apiTransfersService, moment) {
        'ngInject';
        this.$http = $http;
        this.apiTransfersService = apiTransfersService;
        this.cacheService = cacheService;
        this.moment = moment;

        this.transfersByGatewayParams = {
            'init_date': null, // Forcing null this property doesn't send as querystring
            'end_date': null,
            'suppliers': null,
            'gateways': null,
            'has_only_ratecards_for_shuttles': 1,
            'has_only_transfers_without_pickup_time': 0,
            'force_from_hotel_to_airport': 1
        };
    }

    setSupplier(id) {
        this.transfersByGatewayParams.suppliers = id;
    }

    setGateway(id) {
        this.transfersByGatewayParams.gateways = id;
    }

    setEndDate(endDate) {
        this.transfersByGatewayParams.end_date = endDate;
    }

    getGateways() {
        let supplierId = this.cacheService.get('supplier').supplierId;
        this.setSupplier(supplierId);
        return this.apiTransfersService.gatewaysBySupplier.get({suppliers: supplierId}).$promise;
    }

    getTransfersByGateway(gatewayId, formatDate, endDate) {
        this.setGateway(gatewayId);
        endDate = endDate || null;
        this.setEndDate(endDate);
        return this.apiTransfersService.transfersBySupplierAndGateway.get(this.transfersByGatewayParams).$promise.then((response) =>{
            return this.transferCollecitonDataTransformerResponse(response.transfers, formatDate);
        });
    }

    transferCollecitonDataTransformerResponse(data, formatDate) {
        //TODO: data transform
        return data.map((item) => {

            let flightTime = this.moment(item.flightTime, formatDate);
            let timePicker = this.moment(item.latestPickupTime.date);
            let shuttleTimePicker = this.moment(item.shuttleLatestPickupTime.date);
            let earliestDateTime = this.moment(item.earliestPickupTime.date);
            let tempPickupPoint = item.pickupPoint;

            item.flightTime = flightTime.valueOf();
            item.latestPickupTime = timePicker.valueOf();
            item.shuttleLatestPickupTime = shuttleTimePicker.valueOf();
            item.earliestPickupTime = earliestDateTime.valueOf();

            if (item.pickupTime) {
                let pickupTime = this.moment(item.pickupTime, formatDate);
                item.pickupTime = pickupTime.valueOf();
            }

            let timePickerMin = earliestDateTime.clone().toDate();
            let timePickerMax = shuttleTimePicker.clone().toDate();
            let timePickerModel = timePicker.clone().toDate();

            item.transfersTable = {
                //pickupTimeSaved to false allows modifying already stored pickupTimes manually
                pickupTimeSaved: false,
                pickupPointSaved: false,
                pickupPoint: tempPickupPoint,
                tempPickupPoint: tempPickupPoint,
                datePicker: {
                    options: {
                        showWeeks: false,
                        dateModel: null,
                        isOpen: false,
                        maxDate: timePickerMax,
                        minDate: timePickerMin
                    }
                },
                timePicker: {
                    max: timePickerMax,
                    min: timePickerMin,
                    model: timePickerModel
                },
                pointPicker: {
                     options: {
                       isOpen: false
                    },
                },
                dropdownIsOpen: false,
                dropdownPickupPointIsOpen: false,
                saving: false
            };
            return item;
        });
    }

    transferItemDataTransformer(id, timestamp, formatDate, pickupPoint) {
        return {
            op: 'replace',
            path: '/transfers/' + id,
            value: {
                pickupDateTime: this.moment(timestamp).format(formatDate),
                pickupPoint: pickupPoint
            }
        };
    }

    transferCollectionDataTransformerRequest(transfers, formatDate) {
      return transfers.map((item) =>
        this.transferItemDataTransformer(item.transferId, item.pickupTime.valueOf(), formatDate, item.pickupPoint)
      );
    }

    saveTransfers(transfers) {
        return this.apiTransfersService.saveTransfers({'items': transfers});
    }

  downloadTransfersExcel(gatewayIds, endDate, gatewayCod, onlyTransfersWithoutPickupTime) {
    this.setGateway(gatewayIds);
    endDate = endDate || null;
    this.setEndDate(endDate);

    let supplierId = this.transfersByGatewayParams.suppliers;
    let gatewayId = this.transfersByGatewayParams.gateways;

    if (!supplierId || !gatewayId) {
      return;
    }

    this.transfersByGatewayParams.has_only_transfers_without_pickup_time = onlyTransfersWithoutPickupTime;

    let url = apiSuppliersConfig.baseUrl + apiSuppliersConfig.endpoint.downloadTransfersExcel
      .replace(':suppliers', supplierId)
      .replace(':gateways', gatewayId);

    return this.$http({
      method: 'GET',
      url: url,
      params: this.transfersByGatewayParams,
      responseType: 'arraybuffer'
    }).then(response => {
      let date = new Date();
      let formattedDate = date.getFullYear() + '-' +
        String(date.getMonth() + 1).padStart(2, '0') + '-' +
        String(date.getDate()).padStart(2, '0') + '_' +
        String(date.getHours()).padStart(2, '0') + '-' +
        String(date.getMinutes()).padStart(2, '0') + '-' +
        String(date.getSeconds()).padStart(2, '0');

      let fileName = gatewayCod + '_' + formattedDate + '_upcoming_shuttle_transfer.xlsx';
      let blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch(error => {
      window.alert("Error downloading file. Please try again.");
    });
  }

  uploadTransfersExcel(formData) {
    let supplierId = this.transfersByGatewayParams.suppliers;
    let url = apiSuppliersConfig.baseUrl + apiSuppliersConfig.endpoint.uploadTransfersExcel
      .replace(':suppliers', supplierId);

    return this.$http({
      method: 'POST',
      url: url,
      data: formData,
      headers: { 'Content-Type': undefined },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        window.alert("Error uploading file. Please try again.");
      });
  }
}
export default transfersTableService;



// WEBPACK FOOTER //
// ./client/app/common/transfersTable/transfersTable.service.js